
@if (f != null && f.visible) {
    <div [ngClass]="'flex-col gap-1 ' + (_FrontendFieldType.hasLabel(f.type) && f.hasLabel ? 'mb-3 mt-3' : 'mb-2') + (f.indent == 0 ? '' : ' ml-' + f.indent)">
        @if (f.hasLabelAdvanced() && !f.isGuiOneLine()) {
            @if (multipleFields == null) {
                <ng-container *ngTemplateOutlet="labelTemplate; context: { field: f }"></ng-container>
            }
            @else {
                <div class="flex-row gap-1">
                    @for (f2 of multipleFields; track f2; let  i = $index) {
                        @if (f2.visible) {
                            <div class="flex-item-fill" [style.width]="f2.guiWidthInGroup + '%'">
                                @if (f2.hasLabelAdvanced() && !f2.isGuiOneLine() && (f2.guiGroupOwnLabel || f2.guiGroupOwnLabel == null && i == 0)) {
                                    <ng-container *ngTemplateOutlet="labelTemplate; context: { field: f2 }"></ng-container>
                                }
                            </div>
                        }
                    }
                </div>
            }
        }
        @if (multipleFields == null) {
            <app-sm-form-field-wrapper [field]="field" [child]="child2">
                <ng-template #child2>
                    <app-sm-form-field-internal class="width100p" #componentInternal [form]="form" [field]="field" (onClick)="onClick">
                    </app-sm-form-field-internal>
                </ng-template>
            </app-sm-form-field-wrapper>
        }
        @else {
            @if (fixedPos) {
                @for (f2 of multipleFields; track f2) {
                    @if (f2.visible) {
                        <app-sm-form-field-internal #componentInternal [form]="form" [field]="f2" (onClick)="onClick">
                        </app-sm-form-field-internal>
                    }
                }
            }
            @else {
                <div class="flex-row gap-1">
                    @for (f2 of multipleFields; track f2) {
                        @if (f2.visible) {
                            <div class="flex-item-fill" [style.width]="f2.guiWidthInGroup + '%'">
                                <app-sm-form-field-wrapper [field]="f2" [child]="child">
                                    <ng-template #child>
                                        <app-sm-form-field-internal class="width100p" #componentInternal [form]="form" [field]="f2" (onClick)="onClick">
                                        </app-sm-form-field-internal>
                                    </ng-template>
                                </app-sm-form-field-wrapper>
                            </div>
                        }
                    }
                </div>
            }
        }
    </div>
}
<ng-template #labelTemplate let-field="field">
    <span
        class="mr-3"
        [style.text-align]="field.labelRightAligned ? 'right' : 'left'"
        [style.position]="fixedPos ? 'absolute' : undefined"
        [style.left.px]="fixedPos ? field.fixedLabelBounds.x : undefined"
        [style.top.px]="fixedPos ? field.fixedLabelBounds.y : undefined"
        [style.width.px]="fixedPos ? (field.fixedLabelBounds.width + (field.mandatory && mandatoryFieldsRedAsterisk ? 10 : 0)) : undefined"
        [style.height.px]="fixedPos ? field.fixedLabelBounds.height : undefined"
        [style.overflow]="'hidden'"
        >
        <label [pTooltip]="field.tooltip" [tooltipStyleClass]="field.tooltipStyleClasses" [class.req-asterisk] = "field.mandatory && mandatoryFieldsRedAsterisk" [class.req-underline] = "field.mandatory && !mandatoryFieldsRedAsterisk">
            {{field.caption}}
        </label>
        <span *ngFor="let hint of field.guiHints">
            <p-avatar class="hint-icon" styleClass="p-avatar-sm" [icon]="hint.icon" [style]="{'color': '#ffffff', 'background-color': hint.color}" shape="circle" [pTooltip]="hint.toolTip" (onClick)="clickGuiHint(hint)"></p-avatar>
            <span *ngIf="field.isGuiOneLine() && hint.text != null && hint.text != ''" class="ml-2" [style]="{'color': hint.color}">{{hint.text}}</span>
        </span>
    </span>
</ng-template>
